import React from 'react';

import { useApp } from '../../../store/AppContext';
import { fmtDate } from '../../../utils/format';
import { barRadiusClass, LANE_H, laneTop } from '../shared/lanes';

/* Barre d'absence d'un membre : infobulle et ouverture de l'absence au clic. */
export default function AbsenceBar({ sg, dev }) {
  const { days, isManager, openModal, setTimelineHover, timelineDrag, timelineResize } = useApp();
  const truncLeft = sg.realStart < days[0].iso,
    truncRight = sg.realEnd > days[days.length - 1].iso;
  const abs = sg.absObj;
  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={(e) =>
        setTimelineHover({
          x: e.clientX,
          y: e.clientY,
          lines: [
            { label: sg.absLabel, value: '', bold: true },
            { label: 'Période', value: `${fmtDate(sg.realStart)} → ${fmtDate(sg.realEnd)}` },
          ],
        })
      }
      onMouseMove={(e) => setTimelineHover((h) => (h ? { ...h, x: e.clientX, y: e.clientY } : h))}
      onMouseLeave={() => setTimelineHover(null)}
      onClick={(e) => {
        e.stopPropagation();
        setTimelineHover(null);
        if (timelineDrag || timelineResize || !abs) return;
        openModal(
          'absence',
          { devId: dev.id, userId: abs.user_id, devNom: dev.nom, absence: abs },
          {
            type: abs.type,
            debut: abs.debut,
            debut_half: abs.debut_half || 'am',
            fin: abs.fin,
            fin_half: abs.fin_half || 'pm',
          },
        );
      }}
      className={`[grid-row:1] relative rounded-[6px] flex flex-col justify-center gap-[2px] py-[0] px-[8px] overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.15)] opacity-[0.82] ${barRadiusClass(truncLeft, truncRight)} ${isManager ? 'cursor-pointer' : 'cursor-default'}`}
      style={{
        gridColumn: `${sg.sIdx + 1} / ${sg.eIdx + 2}`,
        marginTop: laneTop(sg.lane),
        height: LANE_H,
        background: sg.absColor,
      }}
    >
      <span className="text-[11px] font-semibold text-white whitespace-nowrap overflow-hidden [text-overflow:ellipsis] leading-[1.15]">
        {sg.absLabel}
      </span>
    </div>
  );
}
